// extracted by mini-css-extract-plugin
module.exports = {"paddingBottom":"AddBoard_paddingBottom__2VEkb"};